import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=f38a8a3c&scoped=true"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"
import style0 from "./manage.vue?vue&type=style&index=0&id=f38a8a3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38a8a3c",
  null
  
)

export default component.exports